export default __webpack_public_path__ + "static/media/Metropolis-Regular.80d0e4d1.woff2";